

document.addEventListener('DOMContentLoaded', function() {
  const initCarousels = () => {
    const videoCarousels = document.querySelectorAll('[data-js-video-carousel]');

    videoCarousels.forEach((videoCarousel, index) => {
      if (videoCarousel.dataset.initialized) {
        if (videoCarousel._swiperInstance) {
           videoCarousel.dispatchEvent(new CustomEvent('video-carousel:refresh'));
        }
        return;
      }
      initializeSingleCarousel(videoCarousel, index);
      videoCarousel.dataset.initialized = 'true';
    });
  };

  // MutationObserver para inicialização dinâmica (Infinite Scroll, AJAX)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.hasAttribute('data-js-video-carousel')) {
            initCarousels();
          } else if (node.querySelector('[data-js-video-carousel]')) {
            initCarousels();
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  function initializeSingleCarousel(videoCarousel, cIndex) {
    const swiperContainer = videoCarousel.querySelector('.video-carousel-swiper');
    const modal = videoCarousel.querySelector('[data-js-video-modal]');
    
    if (!swiperContainer) return;
    if (!modal) return;

    let modalVimeoPlayers = [];
    let isGlobalMuted = true;
    let currentModalIndex = 0;
    let isModalOpen = false;
    let swiperInstance = null;
    let modalSwiperInstance = null;
    let progressInterval;
    let currentVimeoPlayerProgress = null;

    const modalWrappers = modal.querySelectorAll('.video-carousel-modal__video-wrapper');
    const modalProgressFills = modal.querySelectorAll('.video-carousel-modal__progress-fill');
    const volumeControls = videoCarousel.querySelectorAll('.video-carousel__volume-control, .video-carousel-modal__volume-control');
    const getCarouselVideos = () => videoCarousel.querySelectorAll('.video-carousel-swiper video[data-video-index]');

    const handleSlideChange = (s) => {
      if (isModalOpen) return;
      processAllVideos(s);
      s.slides.forEach((sl, i) => {
        sl.style.zIndex = (i === s.activeIndex) ? '2' : '1';
        sl.style.height = '';
      });
    };

    // Hidrata src sob demanda (lazy) — espelha o facade do Vimeo
    let sectionNear = false;
    const ensureVideoSrc = (video, force = false) => {
      if (!video || video.dataset.srcLoaded === 'true') return;
      if (!force && !sectionNear) return;
      const src = video.dataset.src;
      if (!src) return;
      video.src = src;
      video.dataset.srcLoaded = 'true';
      video.load();
    };

    // Carrega sources ao aproximar da seção (antes de entrar na viewport)
    const lazySourceObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        sectionNear = true;
        if (swiperInstance && !isModalOpen) {
          processAllVideos(swiperInstance);
          // Recalcula nav após mídia entrar no layout
          swiperInstance.update();
          swiperInstance.navigation?.update();
        }
        lazySourceObserver.disconnect();
      });
    }, { rootMargin: '800px 0px', threshold: 0 });
    lazySourceObserver.observe(videoCarousel);

    // Global Visibility Observer for the carousel section
    const carouselObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          // Pause everything when carousel is out of view
          stopActivePlayWatchdog();
          const videos = swiperContainer.querySelectorAll('video');
          videos.forEach(v => v.pause());
          if (window.vimeoFacade) {
            const facades = swiperContainer.querySelectorAll('[data-fv-facade]');
            facades.forEach(f => window.vimeoFacade.pause(f));
          }
        } else if (!isModalOpen && swiperInstance) {
          // Resume if visible and modal is closed
          processAllVideos(swiperInstance);
        }
      });
    }, { threshold: 0.1 });

    carouselObserver.observe(videoCarousel);

    const clearLoadedDataWait = (video) => {
      if (!video || !video._onLoadedData) return;
      video.removeEventListener('loadeddata', video._onLoadedData);
      video._onLoadedData = null;
    };

    let activePlayWatchdog = null;
    const stopActivePlayWatchdog = () => {
      if (!activePlayWatchdog) return;
      clearInterval(activePlayWatchdog);
      activePlayWatchdog = null;
    };

    const preloadMobileNeighbors = (s) => {
      if (!window.matchMedia('(max-width: 767px)').matches) return;
      const ai = s.realIndex;
      s.slides.forEach((sl, i) => {
        const fromData = parseInt(sl.getAttribute('data-video-index'), 10);
        const logicalIndex = !isNaN(fromData) ? fromData : i;
        if (Math.abs(logicalIndex - ai) !== 1) return;
        const v = sl.querySelector('video');
        if (v) ensureVideoSrc(v);
        const f = sl.querySelector('[data-fv-facade]');
        if (f && window.vimeoFacade) {
          window.vimeoFacade.observeElement(f);
          window.vimeoFacade.loadPlayer(f);
        }
      });
    };

    const startActivePlayWatchdog = (video, sl) => {
      stopActivePlayWatchdog();
      let tries = 0;
      activePlayWatchdog = setInterval(() => {
        tries += 1;
        if (isModalOpen || !video.isConnected || !sl.classList.contains('swiper-slide-active')) {
          stopActivePlayWatchdog();
          return;
        }
        if (!video.paused && !video.ended) {
          if (swiperInstance) preloadMobileNeighbors(swiperInstance);
          stopActivePlayWatchdog();
          return;
        }
        if (tries > 40) {
          stopActivePlayWatchdog();
          return;
        }
        ensureVideoSrc(video, true);
        if (video.dataset.srcLoaded === 'true' && video.readyState >= 2) {
          video.muted = true;
          video.play().catch(() => {});
        }
      }, 300);
    };

    const processAllVideos = (s) => {
      const activeIndex = s.realIndex;
      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      s.slides.forEach((sl, i) => {
        const video = sl.querySelector('video');
        const facade = sl.querySelector('[data-fv-facade]');
        const fromData = parseInt(sl.getAttribute('data-video-index'), 10);
        const fromSwiper = parseInt(sl.getAttribute('data-swiper-slide-index'), 10);
        const logicalIndex = !isNaN(fromData) ? fromData : (!isNaN(fromSwiper) ? fromSwiper : i);

        const isActive = logicalIndex === activeIndex;
        const isNearby = Math.abs(logicalIndex - activeIndex) <= 1;
        const isVisible = sl.classList.contains('swiper-slide-visible');

        // Mobile: só o ativo compete pela rede. Desktop: visíveis/vizinhos.
        const shouldLoad = isMobile
          ? isActive
          : (isVisible || isNearby || isActive);
        const shouldPlay = isMobile
          ? isActive
          : (isVisible || isNearby || isActive);

        if (video) {
          video.muted = true;
          const slideItem = sl.querySelector('.video-carousel__item');

          if (shouldLoad) {
            ensureVideoSrc(video);
          }

          if (shouldPlay) {
            ensureVideoSrc(video);
            if (video.dataset.srcLoaded === 'true') {
              const attemptPlay = () => {
                if (isModalOpen) return;
                if (isMobile && !sl.classList.contains('swiper-slide-active')) return;
                video.play().then(() => {
                  video._playRetryCount = 0;
                  if (isModalOpen || (isMobile && !sl.classList.contains('swiper-slide-active'))) {
                    video.pause();
                    if (slideItem) slideItem.classList.remove('is-playing');
                  } else if (isMobile && swiperInstance) {
                    preloadMobileNeighbors(swiperInstance);
                  }
                }).catch((err) => {
                  if (err.name === 'AbortError') {
                    video._playRetryCount = (video._playRetryCount || 0) + 1;
                    if (video._playRetryCount <= 8) {
                      setTimeout(attemptPlay, Math.min(400, 80 * video._playRetryCount));
                    }
                    return;
                  }
                  if (err.name !== 'NotAllowedError' && slideItem) {
                    slideItem.classList.add('has-error');
                  }
                });
              };

              clearLoadedDataWait(video);
              if (video.readyState >= 2) {
                attemptPlay();
              } else {
                video._onLoadedData = () => {
                  video._onLoadedData = null;
                  attemptPlay();
                };
                video.addEventListener('loadeddata', video._onLoadedData, { once: true });
                video.addEventListener('canplay', attemptPlay, { once: true });
              }
              if (isActive) startActivePlayWatchdog(video, sl);
            } else if (isActive) {
              startActivePlayWatchdog(video, sl);
            }
          } else {
            clearLoadedDataWait(video);
            video._playRetryCount = 0;
            video.pause();
            if (slideItem) slideItem.classList.remove('is-playing');
          }
        }

        if (facade && window.vimeoFacade) {
          if (isModalOpen) {
            window.vimeoFacade.pause(facade);
            return;
          }

          if (shouldLoad) {
            window.vimeoFacade.observeElement(facade);
          }

          if (shouldPlay) {
            window.vimeoFacade.observeElement(facade);
            if (facade.dataset.initialized === 'true') {
              window.vimeoFacade.setVolume(facade, 0);
              window.vimeoFacade.play(facade);
            }
          } else if (facade.dataset.initialized === 'true') {
            window.vimeoFacade.pause(facade);
          }
        }
      });
    };

    const openModal = (index) => {
      isModalOpen = true;
      stopActivePlayWatchdog();
      currentModalIndex = index;
      modal.classList.add('active');
      document.body.classList.add('video-modal-open');
      
      if (window.vimeoFacade) {
        window.vimeoFacade.pauseAll();
      }
      
      const carouselVideos = swiperContainer.querySelectorAll('video');
      carouselVideos.forEach(v => v.pause());

      // Pre-carregamento imediato do vídeo alvo e do próximo
      const f = modalWrappers[index]?.querySelector('[data-fv-facade]');
      if (f && window.vimeoFacade) {
        window.vimeoFacade.loadPlayer(f);
      }
      if (modalWrappers[index + 1]) {
        const nf = modalWrappers[index + 1].querySelector('[data-fv-facade]');
        if (nf && window.vimeoFacade) {
          window.vimeoFacade.loadPlayer(nf);
        }
      }
      
      // Reset all progress bars to a clean state
      updateProgressBars(index);

      // Sync volume UI
      volumeControls.forEach(el => {
        el.classList.toggle('is-muted', isGlobalMuted);
      });
      
      if (modalSwiperInstance) {
        if (modalSwiperInstance.activeIndex === index) {
          showModalStory(index);
        } else {
          modalSwiperInstance.slideTo(index, 0);
        }
      } else {
        showModalStory(index);
      }
    };

    const closeModal = () => {
      isModalOpen = false;
      modal.classList.remove('active');
      document.body.classList.remove('video-modal-open');

      // Pausa tudo no Vimeo e no nativo apenas do modal
      const modalFacades = modal.querySelectorAll('[data-fv-facade]');
      modalFacades.forEach(f => window.vimeoFacade?.pause(f));

      modalWrappers.forEach((wrap) => {
        const v = wrap.querySelector('video');
        const f = wrap.querySelector('[data-fv-facade]');
        if (v) {
          v.pause();
          v.currentTime = 0;
        }
        // Limpar estado is-playing de todos os wrappers e facades do modal
        wrap.classList.remove('is-playing');
        if (f) f.classList.remove('is-playing');
      });

      // Limpeza de ouvintes de progresso
      if (currentVimeoPlayerProgress && typeof currentVimeoPlayerProgress.off === 'function') {
        currentVimeoPlayerProgress.off('timeupdate');
        currentVimeoPlayerProgress.off('ended');
        currentVimeoPlayerProgress = null;
      }

      if (swiperInstance) {
        // Delay resumption to allow modal cleanup to complete
        setTimeout(() => {
          handleSlideChange(swiperInstance);
        }, 100);
      }
    };

    const navigateModal = (direction) => {
      if (modalSwiperInstance) {
        if (direction > 0) modalSwiperInstance.slideNext();
        else modalSwiperInstance.slidePrev();
      } else {
        const nextIdx = currentModalIndex + direction;
        if (nextIdx >= 0 && nextIdx < modalWrappers.length) {
          showModalStory(nextIdx);
        } else if (nextIdx >= modalWrappers.length) {
          closeModal();
        }
      }
    };

    const showModalStory = (index) => {
      currentModalIndex = index;

      // Reset progress bars state
      updateProgressBars(index);

      // Garantir que nenhum outro vídeo esteja tocando antes de iniciar o novo
      if (window.vimeoFacade) {
        window.vimeoFacade.pauseAll();
      }
      modalWrappers.forEach(w => {
        const v = w.querySelector('video');
        if (v) v.pause();
      });

      modalWrappers.forEach((wrap, i) => {
        const active = i === index;
        wrap.classList.toggle('active', active);
        
        const video = wrap.querySelector('video');
        const facade = wrap.querySelector('[data-fv-facade]');

        if (active) {
          if (facade && window.vimeoFacade) {
            window.vimeoFacade.loadPlayer(facade).then(player => {
              if (currentModalIndex !== i) return;

              if (player) {
                // Respeitar o estado global de volume no modal
                player.setMuted(isGlobalMuted).then(() => player.setVolume(isGlobalMuted ? 0 : 1)).catch(() => {});
                window.vimeoFacade.play(facade);
                startProgress(null, player, i);

                // Garantir que o wrapper do modal também receba is-playing
                // para que o CSS .video-carousel-modal__video-wrapper.is-playing funcione
                player.on('playing', () => {
                  wrap.classList.add('is-playing');
                  facade.classList.add('is-playing');
                });
              }
            });
          } else if (video) {
            ensureVideoSrc(video, true);
            // Pré-carrega o próximo do modal
            const nextWrap = modalWrappers[i + 1];
            const nextVideo = nextWrap?.querySelector('video');
            if (nextVideo) ensureVideoSrc(nextVideo, true);

            video.currentTime = 0;
            video.muted = isGlobalMuted;
            video.volume = isGlobalMuted ? 0 : 1;
            // Paridade com Vimeo: is-playing só após o vídeo de fato tocar
            const onPlaying = () => {
              if (currentModalIndex !== i) return;
              wrap.classList.add('is-playing');
              video.removeEventListener('playing', onPlaying);
            };
            video.addEventListener('playing', onPlaying);
            video.play().catch(() => {});
            startProgress(video, null, i);
          }
        } else {
          // Pausar inativos (redundância de segurança)
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
          if (facade && window.vimeoFacade) {
            window.vimeoFacade.pause(facade);
          }
          // Limpar is-playing de wrappers/facades inativos
          wrap.classList.remove('is-playing');
          if (facade) facade.classList.remove('is-playing');
        }
      });
    };

    const startProgress = (video, player, index) => {
      // Busca o fill dinamicamente para evitar dessincronia de index
      const fill = modal.querySelector(`[data-modal-story-index="${index}"] .video-carousel-modal__progress-fill`);
      if (!fill) return;

      if (video) {
        if (video._upd) video.removeEventListener('timeupdate', video._upd);
        const upd = () => {
          if (currentModalIndex !== index) { 
            video.removeEventListener('timeupdate', upd); 
            return; 
          }
          const p = (video.currentTime / video.duration) * 100;
          fill.style.width = p + '%';
          
          if (p > 99 && !video._pseudoEnded) {
            video._pseudoEnded = true;
            advanceCarousel(true);
          } else if (p < 10) {
            video._pseudoEnded = false;
          }
        };
        video._upd = upd;
        video.addEventListener('timeupdate', upd);
        // O evento 'ended' nativo é capturado pelo listener global no final do script
      } else if (player) {
        currentVimeoPlayerProgress = player;
        const onTime = (data) => {
          if (currentModalIndex !== index || !isModalOpen) {
            player.off('timeupdate', onTime);
            return;
          }
          fill.style.width = (data.percent * 100) + '%';
        };
        player.on('timeupdate', onTime);
      }
    };

    const updateProgressBars = (index) => {
      modalProgressFills.forEach((f, i) => {
        if (i < index) f.style.width = '100%';
        else if (i >= index) f.style.width = '0%';
      });
    };

    const initialize = () => {
      if (typeof Swiper === 'undefined') {
        setTimeout(initialize, 500);
        return;
      }

      // Unlock native videos on first interaction
      const unlockNative = () => {
        sectionNear = true;
        const activeVideo = swiperContainer.querySelector('.swiper-slide-active video');
        if (activeVideo) {
          ensureVideoSrc(activeVideo, true);
          if (activeVideo.paused) activeVideo.play().catch(() => {});
        }
        ['touchstart', 'mousedown'].forEach(ev => document.removeEventListener(ev, unlockNative));
      };
      ['touchstart', 'mousedown'].forEach(ev => document.addEventListener(ev, unlockNative, { once: true, passive: true }));

      try {
        swiperInstance = new Swiper(swiperContainer, {
          slidesPerView: 1.3,
          centeredSlides: true,
          centeredSlidesBounds: true,
          loop: false,
          spaceBetween: 10,
          speed: 600,
          slideToClickedSlide: true,
          navigation: {
            nextEl: videoCarousel.querySelector('.swiper-button-next'),
            prevEl: videoCarousel.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            768: {
              slidesPerView: 3.4,
              centeredSlides: false,
              centeredSlidesBounds: false
            },
            1200: {
              slidesPerView: 5,
              centeredSlides: false,
              centeredSlidesBounds: false
            }
          },
          watchSlidesProgress: true,
          on: {
            init: function() {
              this.el.classList.add('swiper-initialized');
              handleSlideChange(this);
            },
            afterInit: function() {
              this.navigation?.update();
              const rect = videoCarousel.getBoundingClientRect();
              const near = rect.top < (window.innerHeight + 800) && rect.bottom > -800;
              if (!near) return;
              sectionNear = true;
              const ai = this.realIndex;
              const activeSlide = this.slides[ai];
              if (activeSlide) {
                const v = activeSlide.querySelector('video');
                if (v) ensureVideoSrc(v, true);
                const f = activeSlide.querySelector('[data-fv-facade]');
                if (f && window.vimeoFacade) window.vimeoFacade.observeElement(f);
              }
              handleSlideChange(this);
            },
            slideChange: function() {
              handleSlideChange(this);
            },
            slideChangeTransitionEnd: function() {
              handleSlideChange(this);
            },
            click: function(s, e) {
              if (e.target.closest('.video-carousel__product-info') || e.target.closest('.video-carousel__volume-control')) return;
              if (e.target.closest('.swiper-button-next, .swiper-button-prev')) return;
              const slide = e.target.closest('.swiper-slide');
              if (slide) {
                const dataIndex = slide.getAttribute('data-video-index');
                const idx = parseInt(dataIndex);
                if (!isNaN(idx)) openModal(idx);
              }
            }
          }
        });

        const modalSwiperContainer = modal.querySelector('.video-carousel-modal-swiper');
        if (modalSwiperContainer) {
          modalSwiperInstance = new Swiper(modalSwiperContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            speed: 400,
            navigation: {
              nextEl: modal.querySelector('.video-carousel-modal__next'),
              prevEl: modal.querySelector('.video-carousel-modal__prev'),
            },
            on: {
              slideChange: function() {
                showModalStory(this.activeIndex);
                
                // Pre-load next modal story
                const nextIdx = this.activeIndex + 1;
                if (nextIdx < this.slides.length) {
                  const nextFacade = this.slides[nextIdx].querySelector('[data-fv-facade]');
                  if (nextFacade && window.vimeoFacade) {
                    window.vimeoFacade.loadPlayer(nextFacade);
                  }
                }
              }
            }
          });
        }
        
        if (swiperInstance && swiperInstance.initialized) {
          swiperInstance.el.classList.add('swiper-initialized');
        }
        
        videoCarousel._swiperInstance = swiperInstance;

        videoCarousel.addEventListener('video-carousel:refresh', () => {
          processAllVideos(swiperInstance);
        });



        volumeControls.forEach(c => c.addEventListener('click', (e) => {
          e.stopPropagation();
          
          if (c.classList.contains('video-carousel-modal__volume-control')) {
            // Toggle volume inside modal
            isGlobalMuted = !isGlobalMuted;
            
            // Update UI
            volumeControls.forEach(el => {
               el.classList.toggle('is-muted', isGlobalMuted);
            });
            
            // Update all active players (native and vimeo)
            const activeModalVideo = modal.querySelector('.video-carousel-modal__video-wrapper.active video');
            if (activeModalVideo) {
              activeModalVideo.muted = isGlobalMuted;
              activeModalVideo.volume = isGlobalMuted ? 0 : 1;
            }
            
            const activeModalVimeo = modal.querySelector('.video-carousel-modal__video-wrapper.active [data-fv-facade]');
            if (activeModalVimeo && window.vimeoFacade) {
              window.vimeoFacade.setVolume(activeModalVimeo, isGlobalMuted ? 0 : 1);
            }
          } else {
            // Open modal from carousel
            const slide = c.closest('.swiper-slide');
            const idx = parseInt(slide?.getAttribute('data-video-index'));
            if (!isNaN(idx)) openModal(idx);
          }
        }));

        const btnClose = modal.querySelector('.video-carousel-modal__close');
        const btnOverlay = modal.querySelector('.video-carousel-modal__overlay');
        const btnPrev = modal.querySelector('.video-carousel-modal__prev');
        const btnNext = modal.querySelector('.video-carousel-modal__next');

        btnClose?.addEventListener('click', (e) => { e.preventDefault(); e.stopImmediatePropagation(); closeModal(); });
        btnOverlay?.addEventListener('click', (e) => { e.preventDefault(); e.stopImmediatePropagation(); closeModal(); });

        // Toggle play/pause on swipe overlay click
        modal.querySelectorAll('.video-carousel-modal__swipe-overlay').forEach(overlay => {
          overlay.addEventListener('click', () => {
             const wrapper = overlay.closest('.video-carousel-modal__video-wrapper');
             const video = wrapper.querySelector('video');
             const facade = wrapper.querySelector('[data-fv-facade]');
             
             if (video) {
               if (video.paused) video.play();
               else video.pause();
             } else if (facade && window.vimeoFacade) {
               window.vimeoFacade.togglePlay(facade);
             }
          });
        });

        // Auto-advance background carousel on video end
        let lastAdvanceTime = 0;
        const advanceCarousel = (isModal = false) => {
          const now = Date.now();
          if (now - lastAdvanceTime < 2000) return;
          lastAdvanceTime = now;
          if (isModal) navigateModal(1);
          else swiperInstance?.slideNext();
        };

        // Centralized handler for auto-advancing
        const handleAutoAdvance = (target, isVimeo = false) => {
          const isModal = target.closest('.video-carousel-modal');
          if (isModal) {
            const wrapper = target.closest('.video-carousel-modal__video-wrapper');
            const modalIndex = parseInt(wrapper?.getAttribute('data-modal-story-index'));
            if (!isNaN(modalIndex) && modalIndex === currentModalIndex) {
              advanceCarousel(true);
            }
          } else {
            const slide = target.closest('.swiper-slide');
            if (slide && slide.classList.contains('swiper-slide-active')) {
              advanceCarousel(false);
            }
          }
        };

        // Escutar eventos customizados do VimeoFacade (inclui o pseudo-ended de 99%)
        videoCarousel.addEventListener('vimeo:ended', (e) => {
          handleAutoAdvance(e.target, true);
        });

        // Escutar eventos 'ended' nativos (borbulhados)
        videoCarousel.addEventListener('ended', (e) => {
          handleAutoAdvance(e.target, false);
        }, true);

        // Escutar eventos de erro em vídeos nativos
        videoCarousel.addEventListener('error', (e) => {
          if (e.target.tagName === 'VIDEO') {
            const item = e.target.closest('.video-carousel__item');
            if (item) item.classList.add('has-error');
          }
        }, true);

        // Escutar quando o vídeo realmente começa a tocar (para remover fallback / opacity)
        videoCarousel.addEventListener('playing', (e) => {
          if (e.target.tagName === 'VIDEO') {
            const carouselSlide = e.target.closest('.video-carousel-swiper .swiper-slide');
            if (carouselSlide && carouselSlide.classList.contains('swiper-slide-active') && swiperInstance) {
              stopActivePlayWatchdog();
              preloadMobileNeighbors(swiperInstance);
            }
            const item = e.target.closest('.video-carousel__item');
            if (item) {
              item.classList.add('is-playing');
              item.classList.remove('has-error');
            }
            // Modal: mesma regra do Vimeo — .is-playing libera opacity do <video>
            const modalWrap = e.target.closest('.video-carousel-modal__video-wrapper');
            if (modalWrap) {
              modalWrap.classList.add('is-playing');
            }
          }
        }, true);

      } catch (err) {}
    };

    initialize();
  }

  initCarousels();
  document.addEventListener('shopify:section:load', () => {
    initCarousels();
  });
  
  // No longer needed to load SDK here as vimeo-facade.js handles it
});
